import type {Theme} from '@chakra-ui/react';
import {extendTheme} from '@chakra-ui/react';
import {deepmerge} from 'deepmerge-ts';

import {tokens as dark} from '../generated/dark';
import {tokens as light} from '../generated/light';
import {overrides, coreTokens} from '../theme-config';

import {cleanTheme} from './clean-theme';
import {components} from './components';
import {global} from './global';
import {mergeColorMode} from './merge-color-mode';
import {shadows} from './shadows';
import {zIndices} from './zIndices';

const semantic = mergeColorMode(light.semantic, dark.semantic);
const core = deepmerge(coreTokens, light.core);
const theme = extendTheme({
  ...core,
  shadows,
  zIndices,
  config: {
    initialColorMode: `light`,
    useSystemColorMode: false,
    cssVarPrefix: `linx`,
  },
  styles: {global},
  semanticTokens: {
    ...semantic,
  },
  components: {
    ...overrides.components,
    ...components,
  },
});

export const uiTheme: Theme = cleanTheme(theme as unknown as Theme);

export default uiTheme;
